module.exports = __webpack_public_path__ + "img/life_cycle_management.b17c8b3a.png";